import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    sessionStorage.getItem("SchemeMaster_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
	
   if(sessionStorage.getItem("SchemeMaster_Action")=="Add")
   {
	    setSaveButtonText("Save");

      
          setSchCode("{Auto}");
       


      //Clear();
   
   }
   else if(sessionStorage.getItem("SchemeMaster_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("SchemeMaster_EditId"));
   }
   else if(sessionStorage.getItem("SchemeMaster_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("SchemeMaster_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }



  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtSchType, setdtSchType]=useState([
    {SchType: "WEIGHT"},
    {SchType: "AMOUNT"}
  ]);


  const [btndisabled, setDisabled] = useState('disabled');

  const [SchCode, setSchCode, SchCodeRef] = useStateRef('{Auto}');
  const [SchemeName, setSchemeName, SchemeNameRef] = useStateRef('');
   const [ShortName, setShortName, ShortNameRef] = useStateRef('');
   const [SchType, setSchType, SchTypeRef] = useStateRef('WEIGHT');
   const [NoOfIns, setNoOfIns, NoOfInsRef] = useStateRef('');
   const [MinIns, setMinIns, MinInsRef] = useStateRef('');
   const [Active, setActive, ActiveRef] = useStateRef(true);
  

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}


async function ControlSettings()
{

  if((sessionStorage.getItem("SchemeMaster_Action")=="Edit") || (sessionStorage.getItem("SchemeMaster_Action")=="Delete"))
   {
  
   }


}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    const results = await apiService.postCall("schememaster/Display",postData);

   if (results != "-1") {
     
	 let HeadData=results.data.Head;
     
      setSchCode(HeadData[0][0].SchCode);
      setSchemeName(HeadData[0][0].SchemeName);
      setShortName(HeadData[0][0].ShortName);
      setSchType(HeadData[0][0].SchType);
      setNoOfIns(HeadData[0][0].NoOfIns);
      setMinIns(HeadData[0][0].MinIns);
      setActive(HeadData[0][0].Active);
      
      getLookup();
       
   }  
  }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
		let postData = {
			"Action" : sessionStorage.getItem("SchemeMaster_Action"),
			"EditId" : sessionStorage.getItem("SchemeMaster_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "SchemeName":SchemeNameRef.current,
      "ShortName":ShortNameRef.current,
      "SchType":SchTypeRef.current,
      "NoOfIns":NoOfInsRef.current,
      "MinIns":MinInsRef.current,
      "Active":ActiveRef.current,
      }

    let ErrMsg="";
    
    if(val(postData.MinIns)==0)
      {
        ErrMsg="Please Enter Min Ins";
      }

      if(val(postData.NoOfIns)==0)
        {
          ErrMsg="Please Enter No Of Ins";
        }

        
    if(postData.SchType.length==0)
      {
        ErrMsg="Please Select Scheme Type";
      }

      if(postData.ShortName.length==0)
        {
          ErrMsg="Please Enter Short Name";
        }

        
    if(postData.SchemeName.length==0)
    {
      ErrMsg="Please Enter Scheme Name";
    }

       
  
if(ErrMsg=="")
{
   const results = await apiService.postCall("schememaster/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{
  swal({
    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("SchemeMaster_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("SchemeMaster_Action")=="Edit")
   {
    swal({
      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"
    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("SchemeMaster_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "info",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }


  async function getLookup(){
	 try {		
				 
		let postData = {
      "TransType" : ""
    };
		
    const results = await apiService.postCall("schememaster/Lookup",postData);

	 if (results != "-1") {


  
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/chit/schememaster/list');
  };


  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

              <div className='row'>
              </div>

                <div className='row'>
                  <div className='col-lg-6'>
                       
                        <div className='row py-2'>
                          <div className='col-md-3'>
                            <Form.Label>Code</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtBillNo" placeholder="" value={SchCode}  />
                          </div>
                         
                          <div className='col-md-9'>
                            <Form.Label>Scheme Name</Form.Label>
                            <Form.Control type="text" placeholder="" value={SchemeName} onChange={(e)=>setSchemeName(e.target.value)} />
                          </div>
						  
                          <div className='col-md-6'>
                            <Form.Label>Short Name</Form.Label>
                            <Form.Control type="text" placeholder="" value={ShortName} onChange={(e)=>setShortName(e.target.value)} />
                          </div>
						  
                          <div className='col-md-6'>
                          <Form.Label>Scheme Type</Form.Label>
                <select className="form-select" value={SchType}
                              onChange=
                              {
                                (e) => {
                              setSchType(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtSchType.map(
                              (item)=>(
                              <option value={item.SchType}>{item.SchType}</option>
                              )
                              )
                              }
                             </select>
</div>


                          <div className='col-md-6'>
                            <Form.Label>No.Of Installment</Form.Label>
                            <Form.Control type="text" placeholder="" value={NoOfIns} onChange={(e)=>setNoOfIns(e.target.value)} />
                          </div>
                          <div className='col-md-6'>
                            <Form.Label>Minimum Installment</Form.Label>
                            <Form.Control type="text" placeholder="" value={MinIns} onChange={(e)=>setMinIns(e.target.value)} />
                          </div>

                          <div className='col-md-6'>
                              <Form.Label>Active</Form.Label>
                            <Form.Check type="switch" value={Active} checked={Active} id="chkPartSales" onChange={(e) => {
                              setActive(e.target.checked);
                              }}  placeholder="" />
                            </div>
</div>
</div>




                  </div>
                 
                  <div className='row'>
                  <div className='col-lg-12'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>

                       
   

     

     


  
                          </div>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
             	

              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
